import Vue from 'vue'
import Vuex from 'vuex'

import nav from './modules/nav'
import getters from './getters';

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: { nav },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js